export default __webpack_public_path__ + "static/media/slide03.c77b541b.jpg";